import { StyledH2 } from "@aureskonnect/react-ui";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ReactSwitch from "react-switch";
import store, { setLicenceGodia, setLoyaltyAccount } from "../store";
import { Input } from "reactstrap";
import { SupportCodeModal } from "@pages/Applications/DeviceAssociateModal/MoneticsApplicationForm/SupportCodeModal";

export default function LoyaltyAccount({ selectedRows }: any) {
    const { t } = useTranslation();

    const isActivation = selectedRows[0]?.ActivationLoyaltyAccount ?? false;
    const [isAuthorized, setIsAuthorized] = React.useState<boolean>(
        selectedRows[0]?.Autorisation ?? false
    );

    const licenceGodiaData = selectedRows[0]?.["composite Products"]
        ?.licenceGodia ??
        store.optionComposite?.licenceGodia ?? {
            ActivationGodia: 0,
            licenceGodia: "",
            Paramavantages: 1,
        };

    const [godia, setGodiaState] = React.useState(() => ({
        ActivationGodia: licenceGodiaData.ActivationGodia,
        licenceGodia: licenceGodiaData.licenceGodia,
        Paramavantages: licenceGodiaData.Paramavantages,
    }));

    const [isSupportModalOpen, setIsSupportModalOpen] = React.useState(false);
    const [codeSupport, setCodeSupport] = React.useState("");
    const [isInvalidCode, setIsInvalidCode] = React.useState(false);
    const [pendingActivation, setPendingActivation] = React.useState<boolean>(
        false
    );

    const handleGodiaParamChange = (checked: number) => {
        const updatedGodia = { ...godia, Paramavantages: checked };
        setGodiaState(updatedGodia);
    };

    const handleGodiaActivation = (checked: boolean) => {
        setPendingActivation(checked);
        setCodeSupport("");
        setIsInvalidCode(false);
        setIsSupportModalOpen(true);
    };

    const handleSupportCodeValidated = () => {
        setGodiaState({ ...godia, ActivationGodia: pendingActivation ? 1 : 0 });
    };

    const handleInterconnectionKey = (text: string) => {
        const updatedGodia = { ...godia, licenceGodia: text };
        setGodiaState(updatedGodia);
    };

    const isValid = /^[A-F0-9]{5}-[A-F0-9]{5}-[A-F0-9]{5}-[A-F0-9]{5}$/.test(
        godia.licenceGodia
    );

    useEffect(() => {
        setLoyaltyAccount({ isAuthorized });
        setLicenceGodia(godia);
    }, [isAuthorized, godia]);

    return (
        <React.Fragment>
            <StyledH2
                style={{
                    font: "normal normal 400 27px/41px Segoe UI",
                    color: "#000000",
                    opacity: "1",
                }}
                className="ml-5 pt-3"
            >
                {t("Loyalty account")}
            </StyledH2>

            {/* Softavera loyalty */}
            <div className="d-flex align-items-center justify-content-between">
                <StyledH2
                    style={{
                        font: "normal normal 400 20px/27px Segoe UI",
                        color: "#000000",
                        opacity: "1",
                    }}
                    className="ml-5 pt-3"
                >
                    {t("Softavera loyalty")}
                </StyledH2>
            </div>

            <div className="d-flex align-items-center justify-content-between mt-3 mb-3 ml-3 px-5">
                <div
                    className="ml-5 "
                    style={{
                        font: "normal normal 400 16px/24px Segoe UI",
                        color: "#000000",
                        opacity: "1",
                    }}
                >
                    {t("Authorize payment by loyalty points")}
                </div>
                <div className="float-right mr-4 cac_icn_authorizePaymentLoyaltyPoints">
                    <ReactSwitch
                        disabled={!isActivation}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        handleDiameter={26}
                        offColor="#f7b4b8"
                        offHandleColor="#E30613"
                        checked={isAuthorized}
                        onChange={(e) => setIsAuthorized(e)}
                        onColor="#c2eddd"
                        onHandleColor="#34C38F"
                        width={55}
                        height={20}
                    />
                </div>
            </div>

            <div className="border-footer__clz m-1 px-2 option__clz " />
            <div>
                <div
                    className="d-flex align-items-center justify-content-between mt-3"
                    style={{ width: "97%" }}
                >
                    <StyledH2
                        style={{
                            font: "normal normal 400 20px/27px Segoe UI",
                            color: "#000000",
                            opacity: "1",
                        }}
                        className="ml-5 pt-3"
                    >
                        {t("Godia loyalty")}
                    </StyledH2>
                    <div
                        data-testid="godia-activation-switch"
                        className="float-right mr-4 cac_icn_loyaltyAccountActivation"
                    >
                        <ReactSwitch
                            uncheckedIcon={false}
                            checkedIcon={false}
                            handleDiameter={26}
                            offColor="#f7b4b8"
                            offHandleColor="#E30613"
                            checked={Boolean(godia.ActivationGodia)}
                            onChange={handleGodiaActivation}
                            onColor="#c2eddd"
                            onHandleColor="#34C38F"
                            width={55}
                            height={20}
                        />
                    </div>
                </div>

                {/* Recompences option */}
                <div className="d-flex align-items-center justify-content-start mt-3 ml-3 px-5">
                    <div className="float-right mr-4 cac_icn_authorizePaymentLoyaltyPoints ml-5">
                        <input
                            data-testid="godia-param-recompences"
                            type="radio"
                            name="godiaParamavantages"
                            id="recompences"
                            disabled={!godia.ActivationGodia}
                            checked={godia.Paramavantages === 1}
                            onChange={() => handleGodiaParamChange(1)}
                        />
                    </div>
                    <div
                        style={{
                            font: "normal normal 400 16px/24px Segoe UI",
                            color: "#000000",
                            opacity: "1",
                        }}
                    >
                        {t("Recompences")}
                    </div>
                    <div className="float-right mr-4 cac_icn_authorizePaymentLoyaltyPoints"></div>
                </div>

                {/* Payment option */}
                <div className="d-flex align-items-center justify-content-start mt-3 ml-3 px-5">
                    <div className="float-right mr-4 cac_icn_authorizePaymentLoyaltyPoints ml-5">
                        <input
                            data-testid="godia-param-authorize-payment"
                            type="radio"
                            name="godiaParamavantages"
                            id="authorizePayment"
                            disabled={!godia.ActivationGodia}
                            checked={godia.Paramavantages === 2}
                            onChange={() => handleGodiaParamChange(2)}
                        />
                    </div>
                    <div
                        style={{
                            font: "normal normal 400 16px/24px Segoe UI",
                            color: "#000000",
                            opacity: "1",
                        }}
                    >
                        {t("Authorize payment by loyalty points")}
                    </div>
                </div>

                {/* Interconnection key */}
                <div className="d-flex align-items-center justify-content-between mt-4 ml-3 px-5">
                    <div
                        className="ml-5"
                        style={{
                            font: "normal normal 400 16px/24px Segoe UI",
                            color: "#000000",
                            opacity: "1",
                        }}
                    >
                        {t("Interconnection Key")}
                    </div>
                    <div
                        className="float-right mr-4 cac_icn_authorizePaymentLoyaltyPoints"
                        style={{ width: "30%" }}
                    >
                        <Input
                            data-testid="godia-interconnection-key"
                            disabled={!godia.ActivationGodia}
                            type="text"
                            className="form-control epb_inp_timeAS mr-2"
                            value={godia.licenceGodia}
                            invalid={godia.licenceGodia !== "" && !isValid}
                            onChange={(e) =>
                                handleInterconnectionKey(e.target.value)
                            }
                        />
                    </div>
                </div>
            </div>
            {isSupportModalOpen && (
                <SupportCodeModal
                    isModalOpened={isSupportModalOpen}
                    setIsModalOpened={setIsSupportModalOpen}
                    codeSupport={codeSupport}
                    setCodeSupport={setCodeSupport}
                    isValidCode={isInvalidCode}
                    setIsValidCode={setIsInvalidCode}
                    isConfig={true}
                    setIsModalConfigOpened={handleSupportCodeValidated}
                />
            )}
        </React.Fragment>
    );
}
